import Card from '../../components/Card';
import styles from './ScanCard.module.css';
import InfoMessage from '../../components/InfoMessage';
import MaterialIconsReact from 'material-icons-react';
import Button from '../../components/Button';
import { useContext, useState } from 'react';
import Modal from '../../components/Modal';
import { assignBinToPO } from '../../services/qcService';
import { UserContext } from '../../context/UserContext';

function ScanCard(props) {
  const [showBinConfirm, setShowBinConfirm] = useState(false);
  const {toastList, setToastList, currentFactory, setShowLoadingFull} = useContext(UserContext);

  const addNewBin = async () => {
    setShowBinConfirm(false);
    setShowLoadingFull(true);
    try {
      const response = await assignBinToPO({
        factory_code: currentFactory.item_code,
        po_code: props.boardScanData.parts[0].po_code
      })
      if (response.status !== 200) {
        showToast({type: 'error', message: response.message || 'Internal server error. Kindly try again!', autoClose: false});
      } else {
        showToast({type: 'success', message: `New Bin (${response.message.bin}) is allocated to the ${props.boardScanData.parts[0].po_code}`, autoClose: false});
      }
    } catch (err) {
      showToast({type: 'error', message: err.message || 'Internal server error. Kindly try again!', autoClose: false});
    }
    setShowLoadingFull(false);
  }

  const showToast = ({type, message, autoClose = true}) => {
    // show toast message
    let toast = {
      type: type,
      text: message,
      onClick: undefined,
      autoClose: autoClose
    }
    setToastList([...toastList, toast]);
  }

  return (
    <Card>
      <div className={styles.cardHeader}>
        <div className={styles.contentWrapper}>
          <div>
            <div className='bold ft-20'>{props.boardScanData.parts[0].po_code}</div>
            <div className={styles.subText}>{props.boardScanData.total_parts_for_po} Panels</div>
          </div>
        </div>
        <div className={styles.flexContainer}>
          {props.showQCRN && <Button onClick={() => props.requestQCNumber(props.boardScanData.parts[0].po_code)} className={styles.mr16} data-testid="retryQC" type={'primary'}>Generate QCRN</Button>}
          <InfoMessage message='Scan a panel to start the process'></InfoMessage>
        </div>
      </div>
      <div className='line'></div>
      <div className={styles.cardContent}>
        <div className={styles.leftContent}>
          <div className={styles.panelHeader}>
            <div>Panels in this PO</div>
            <div>{props.boardScanData.parts.filter(part => (part.status === 'pending' || part.status === 'approved')).length + ' / ' + props.boardScanData.total_parts_for_po}</div>
          </div>
          <ul className={styles.panelList}>
            {props.boardScanData.parts.map((panel, index) => {
              return (
                <li key={index}>
                  {(panel.status === 'pending' || panel.status === 'approved') && <MaterialIconsReact size={20} color={'#469E59'} icon={'check_circle'}></MaterialIconsReact>}
                  {(!panel.status || panel.status === 'rejected')  && <MaterialIconsReact size={20} color={'#666666'} icon={'check_circle'}></MaterialIconsReact>}
                  {/* <MaterialIconsReact size={20} color={panel.status === 'pending' ? '#469E59' : '#666666'} icon={'check_circle'}></MaterialIconsReact> */}
                  <span className={styles.ml8}>{panel.part}</span>
                </li>
              )
            })}
          </ul>
        </div>
        <div className={styles.rightContent}>
          <img className={styles.materialImage} src={require('../../assets/bin.png')}></img>
          <p className={styles.binText}>{props.boardScanData.parts.reduce((result, part) => {
            if (part.bin !== 0 && result.indexOf(part.bin) === -1) {
              result.push(part.bin)
            }
            return result;
          }, []).join(', ')}</p>
          <Button data-testid="addNewBin" type={'linkPrimary'} onClick={() => setShowBinConfirm(true)}>+ Add a bin</Button>
        </div>
        {showBinConfirm && <Modal title={'Confirm'} onClose={() => setShowBinConfirm(false)} primaryAction={addNewBin}>
          <div>Are you sure you want to add new bin? All newly added panels will be assigned to the new bin.</div>
        </Modal>}
      </div>
    </Card>
  );
}

export default ScanCard;
